// Item library evaluate codes for /roads-sewers/storm-sewers Cellular Attenuation
// build-up dev-mode display — mirrors prelimsMapping.ts's description -> code
// lookup pattern. All rows are static text (stormBuildUpCellularAttenuation.ts),
// so a plain exact-match table is enough, no dynamic patterns needed.
//
// "1mm thick polypropelene membrane seal around units" and "Cart to be added
// into Site Clearance" have no code and are intentionally left out of the map.

export interface StormCellularAttenuationEvaluateCodeItem {
  description: string;
  code: string;
}

export const CELLULAR_ATTENUATION_EVALUATE_CODES: StormCellularAttenuationEvaluateCodeItem[] = [
  { description: 'Excavate & Cart Onsite', code: 'APATT001' },
  { description: 'Level & Compact Formation', code: 'ALP035' },
  { description: 'Earthwork Support', code: 'ALP020a' },
  { description: 'Terram surround', code: 'ALP031' },
  { description: 'Sand Bed & Surround', code: 'GWALP050' },
  { description: 'Supply & Fit 1m x 0.4m x 0.5m Crates', code: 'GWALPDD055' },
  { description: 'Supply & Fit 1m x 0.4m x 0.5m Crates - Sub Contract', code: 'SCSATT001' },
  { description: 'Backfill Crush to formation Hard Landscaping', code: 'ALP017' },
  { description: 'Backfill as dug to formation Soft Landscaping', code: 'GWALP034' },
];

export function findCellularAttenuationEvaluateCode(description: string): string | undefined {
  // The crate size is per-tank configurable ("Supply & Fit 2m x 0.5m x 0.5m Crates"),
  // so normalise it back to the default wording before the exact-match lookup.
  const normalised = description.replace(/^Supply & Fit .+? Crates( - Sub Contract)?$/, 'Supply & Fit 1m x 0.4m x 0.5m Crates$1');
  return CELLULAR_ATTENUATION_EVALUATE_CODES.find((i) => i.description === normalised)?.code;
}
